(function ProfileAddCertificateControllerDefinition() {
    'use strict';

    angular.module('Profile')
        .controller('ProfileAddCertificateController', [
            '$scope', 'config', '$state', '$translate', 'errorsExtend', 'profileCertificateService', 'authExtend', 'loginService', 'notificationService', 'certificateService',
            function organizationalUnitAddCertificateController($scope, config, $state, $translate, errors, profileCertificateService, authExtend, loginService, notificationService, certificateService) {

                var fileUploadInfo = null;

                var resetFileUpload = function resetFileUploadFn() {
                    fileUploadInfo = $scope.fileUploadInfo = {
                        loadedFile: null,
                        selectedFile: null,
                        promise: null,
                        progress: -1
                    };
                };

                $scope.onFileSelect = function onFileSelect(files) {
                    if (files && files.length && files[0].type.indexOf('pkcs') > -1) {

                        if (fileUploadInfo.promise !== null) {
                            fileUploadInfo.promise.abort();
                            fileUploadInfo.promise = null;
                        }
                        fileUploadInfo.progress = -1;

                        // me interesa solo un archivo
                        fileUploadInfo.selectedFile = files[0];

                        if ($scope.fileReaderSupported) {

                            var fileReader = new FileReader();

                            fileReader.readAsDataURL(files[0]);

                            fileReader.onload = function (e) {
                                $scope.$apply(function () {
                                    $scope.fileUploadInfo.loadedFile = e.target.result;
                                });
                            };
                        }
                    }
                };

                $scope.removeCertificate = function () {
                    resetFileUpload();
                };

                $scope.cancel = function () {
                    $state.goBack('inicio');
                };

                $scope.save = function () {
                    if (!$scope.certificateUploadForm.$valid) {
                        $scope.certificateUploadForm.$setSubmitted();
                        errors.showError('VerifyFormData');
                        return false;
                    }

                    if ($scope.showFormEncode && !fileUploadInfo.selectedFile) {
                        errors.showError('VerifyFormFile');
                        return false;
                    }

                    if (fileUploadInfo.promise !== null) {
                        fileUploadInfo.promise.abort();
                        fileUploadInfo.promise = null;
                    }

                    return profileCertificateService.upload($scope.certificate, fileUploadInfo.selectedFile).then(function () {
                        loginService.getById().then(function (result) {
                            notificationService.deleteNotifications(authExtend.getUserId()).then(function () {

                                var notificationDate = new Date($scope.certificate.expirationDate);
                                notificationDate.setDate($scope.certificate.expirationDate.getDate() - 30);

                                var params = {
                                    organizationalUnitId: authExtend.getOrganizationId(),
                                    owner: authExtend.getUserId(),
                                    ownerName: result.lastName + ' ' + result.firstName,
                                    mail: result.mail,
                                    notificationDate: notificationDate
                                };

                                notificationService.createEmployerCertificateExpirateNotifications(params).then(function (result) {
                                    $state.go('inicio');
                                }, function (error) {
                                    $state.go('inicio');
                                });
                            });
                            errors.showSuccess('ProfileCertificateUploadedSuccessfully');
                            $state.go('inicio');
                        }, function (error) {
                            errors.showError(error);
                        });
                    },
                        function (error) {
                            errors.showError(error);
                        });
                };

                $scope.load = function () {
                    $scope.certificateTypes = [];
                    $scope.certificateProviders = [];
                    $scope.showFormEncode = false;
                    $scope.showFormNacion = false;
                    $scope.showFormLakout = false;
                    $scope.showFormPassword = false;

                    $scope.fileReaderSupported = window.FileReader !== undefined && window.FileReader !== null && (window.FileAPI === null || window.FileAPI === undefined || window.FileAPI.html5 !== false);
                    resetFileUpload();
                    $scope.certificate = {
                        userId: authExtend.getUserId(),
                        organizationalUnitId: authExtend.getOrganizationId(),
                        type: undefined,
                        providerId: undefined,
                        expirationDate: undefined,
                        revocationPin: '',
                        notInTree: true
                    };

                    certificateService.getTypes().then(function (result) {
                        $scope.certificateTypes = result;
                    }, function (error) {
                        errors.showError(error);
                        $scope.cancel();
                    });
                };

                $scope.typeChanged = function () {
                    if ($scope.selectedType) {
                        $scope.certificate.type = $scope.selectedType.id;

                        certificateService.getProviders($scope.selectedType.id, authExtend.getOrganizationId()).then(function (result) {
                            $scope.certificateProviders = result;

                            if (result.length === 1) {
                                $scope.selectedProvider = result[0];
                                $scope.providerChanged();
                            } else {
                                $scope.selectedProvider = undefined;
                                $scope.showFormEncode = false;
                                $scope.showFormNacion = false;
                                $scope.showFormLakout = false;
                                $scope.showFormPassword = false;
                                $scope.certificateUploadForm.$setPristine();
                            }
                        }, function (error) {
                            errors.showError(error);
                        });
                    }
                };

                $scope.providerChanged = function () {
                    $scope.certificate.providerId = $scope.selectedProvider.id;
                    $scope.checkExistingCertificate($scope.organizationalUnit);
                    $scope.showFormEncode = $scope.certificate.providerId === 1;
                    $scope.showFormNacion = $scope.certificate.providerId === 2;
                    $scope.showFormLakout = $scope.certificate.providerId === 3;
                    $scope.showFormPassword = $scope.certificate.providerId === 4;
                };

                $scope.checkExistingCertificate = function (organizationalUnit) {
                    if ($scope.selectedProvider && $scope.selectedType) {
                        $scope.certificate.organizationalUnitId = organizationalUnit && ($scope.selectedProvider.name === 'Encode' || $scope.selectedProvider.name === 'Clave') ? organizationalUnit.id : undefined;
                        $scope.existingCertificate = undefined;

                        var filters = {
                            userId: authExtend.getUserId(),
                            organizationalUnitId: $scope.certificate.organizationalUnitId,
                            certificateTypeId: $scope.selectedType.id,
                            certificateProviderId: $scope.selectedProvider.id,
                            cuil: $scope.certificate.cuil
                        };

                        certificateService.get(filters).then(function (result) {
                            $scope.existingCertificate = result;
                            $scope.existingCertificate.provider = $scope.selectedProvider.name;
                            if (organizationalUnit) {
                                $scope.existingCertificate.organizationalUnitName = organizationalUnit.name;
                            }
                        }, function (error) {
                            $scope.existingCertificate = undefined;
                        });
                    }
                };

                $scope.load();

                $scope.$watch('organizationalUnit', function (newValue, oldValue) {
                    $scope.checkExistingCertificate(newValue);
                });
            }
        ]);
})();
